import { watch } from 'vue'

import devtools from 'devtools-detect/index.js'

const loop = () => {
  alert('非法调试, 请关闭调试终端后重新刷新页面')
  window.opener = null
  window.open(' ', '_self')
  window.close()
}

const disableConsole = () => {
  //在本网页的任何键盘敲击事件都是无效操作 （防止F12和shift+ctrl+i调起开发者工具）
  // window.onkeydown =
  //   window.onkeyup =
  //   window.onkeypress =
  //     function () {
  //       return false
  //     }
  //禁用开发者工具F12
  document.onkeydown = function () {
    if (window.event && window.event.keyCode == 123) {
      return false
    }
  }
  let userAgent = navigator.userAgent
  if (userAgent.indexOf('Firefox') > -1) {
    let checkStatus
    let devtools = /./
    devtools.toString = function () {
      checkStatus = 'on'
    }
    setInterval(function () {
      checkStatus = 'off'
      console.log(devtools)
      console.log(checkStatus)
      console.clear()
      if (checkStatus === 'on') {
        let target = ''
        try {
          window.open('about:blank', (target = '_self'))
        } catch (err) {
          let a = document.createElement('button')
          a.onclick = function () {
            window.open('about:blank', (target = '_self'))
          }
          a.click()
        }
      }
    }, 200)
  } else {
    //禁用控制台
    let ConsoleManager = {
      onOpen: function () {
        alert('Console is opened')
      },
      onClose: function () {
        alert('Console is closed')
      },
      init: function () {
        let self = this
        let x = document.createElement('div')
        let isOpening = false,
          isOpened = false
        Object.defineProperty(x, 'id', {
          get: function () {
            if (!isOpening) {
              self.onOpen()
              isOpening = true
            }
            isOpened = true
            return true
          }
        })
        setInterval(function () {
          isOpened = false
          console.info(x)
          console.clear()
          if (!isOpened && isOpening) {
            self.onClose()
            isOpening = false
          }
        }, 200)
      }
    }
    ConsoleManager.onOpen = function () {
      //打开控制台，跳转
      let target = ''
      try {
        window.open('about:blank', (target = '_self'))
      } catch (err) {
        let a = document.createElement('button')
        a.onclick = function () {
          window.open('about:blank', (target = '_self'))
        }
        a.click()
      }
    }
    ConsoleManager.onClose = function () {
      alert('Console is closed!!!!!')
    }
    ConsoleManager.init()
  }
}

const disabled = () => {
  document.oncontextmenu = new Function('event.returnValue=false')
  document.onselectstart = new Function('event.returnValue=false')
  //FIXME
  // window.addEventListener('devtoolschange', (event) => {
  //   console.log('devtoolschange', event.detail.isOpen)
  //   // if (event.detail.isOpen) loop()
  // })

  window.onload = function () {
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    document.addEventListener('gesturestart', function (event) {
      event.preventDefault()
    })
  }
  disableConsole()

  // if (devtools.isOpen) loop()
  // watch(
  //   () => devtools,
  //   (val) => {
  //     console.log('v', val)
  //     if (val.isOpen) loop()
  //   },
  //   { immediate: true, deep: true }
  // )

  var ConsoleManager = {
    // onOpen() {
    //   alert('Console is opened')
    // },
    // onClose() {
    //   alert('Console is closed')
    // },
    init() {
      var self = this
      var x = document.createElement('div')
      var isOpening = false,
        isOpened = false
      Object.defineProperty(x, 'id', {
        get() {
          if (!isOpening) {
            self.onOpen()
            isOpening = true
          }
          isOpened = true
        }
      })
      setInterval(function () {
        isOpened = false
        console.info(x)
        console.clear()
        if (!isOpened && isOpening) {
          self.onClose()
          isOpening = false
        }
      }, 200)
    }
  }

  ConsoleManager.onOpen = function () {
    // alert('Console is opened!!!!!')
  }
  ConsoleManager.onClose = function () {
    // alert('Console is closed!!!!!')
  }
  ConsoleManager.init()
}

process.env.NODE_ENV === 'production' ? disabled() : null
